module.exports = __webpack_public_path__ + "static/media/icon-logo-share.53d82d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-logo-share.png
// module id = 1921
// module chunks = 6